// Should stay in sync with resourceCategory.mjs

export default {
  GETTING_STARTED: 0,
  APPRAISAL_VALUE: 1,
  VIP_ENGAGEMENT: 2
};
